exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lastUpdateTime[data-v-48888fc2] {\r\n    font-size: 14px;\r\n    color: #787b82;\r\n    margin-right: 15px;\n}\r\n", ""]);

// exports
